import { useFarm } from "@/context/FarmContext";
import { Tractor } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export function PageHeader({ title, subtitle, action }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-extrabold tracking-tight text-[hsl(148,38%,16%)] leading-none">{title}</h1>
        {subtitle && <p className="text-muted-foreground mt-2 text-sm sm:text-base">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export function NoFarm() {
  const navigate = useNavigate();
  return (
    <div className="max-w-md mx-auto text-center py-20" data-testid="no-farm-empty-state">
      <div className="mx-auto grid place-items-center h-16 w-16 rounded-2xl bg-secondary text-primary mb-6">
        <Tractor className="h-8 w-8" />
      </div>
      <h1 className="font-display text-2xl font-extrabold tracking-tight text-[hsl(148,38%,16%)]">No farm yet</h1>
      <p className="text-muted-foreground mt-3">Create your first farm to start tracking grass and feed.</p>
      <Button className="mt-6 rounded-full" data-testid="create-first-farm-button" onClick={() => navigate("/app/farm?new=1")}>
        Set up a farm
      </Button>
    </div>
  );
}

export function useRequireFarm() {
  const { farm, loading } = useFarm();
  return { farm, loading };
}
